// Games to exclude from FREE_SPIN selection (by name)
// These games are not supported for free spin features
export const EXCLUDED_GAME_NAMES = [
	'Honey Trap of Diao Chan',
	'Dragon Hatch',
	"Emperor's Favour",
	'Fortune Gods',
	'Fortune Mouse',
	'Fortune Tiger',
	'Galactic Gems',
	'Hotpot',
	'Piggy Gold',
	'Prosperity Lion',
	'Rave Party Fever',
	'Secret of Cleopatra',
	'Shaolin Soccer',
	'Totem Wonders',
	'Medusa',
	'Fortune Tree',
	'Hood vs Wolf',
	'Destiny of Sun & Moon',
	'Bikini Paradise',
	"Raider Jane's Crypt of Fortune",
	'Fortune Dragon',
	'Leprechaun Riches',
	'Rooster Rumble',
	'Gem Saviour Conquest',
]
